import { SUPPORT_EMAIL } from "constants/index";

// Every "email support" affordance in the app opens the user's mail client with
// a prefilled subject, so the address and the encoding live in one place.
export function buildSupportMailtoLink(subject: string): string {
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;
}
